import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getCouponsStoreByIdAction,
  getFeatureCardsAction,
  getTopVisitedStores,
} from "../../../Store/actions";
import "../../../Assets/Scss/Store.scss";
import Head from "./Head";
import Loader from "../../Ui/Loader";
import { Col, Container, Row, Dropdown, DropdownButton } from "react-bootstrap";
import CouponCardHorizontal from "../../Ui/CouponCardHorizontal";
import { Link } from "react-router-dom";
import {
  getCouponByIdAction,
  getEndUserAction,
} from "../../../Store/Coupons/actions";
import Pagniation from "../../Ui/CustomPagination";
import NewsLetter from "../../NewsLetter/NewsLetter";
import MonthYearMacros from "../../Ui/MonthYearMacros";
import Banner from "./Banner.jsx";
import Slider from "./Banner2";
import { Helmet } from "react-helmet";
import API, { BASE_URL } from "../../../Config/axiosInstance";
import { BiFilterAlt } from "react-icons/bi";
function Index({ match, history }) {
  const dispatch = useDispatch();

  const { topRatedStores } = useSelector((state) => state.Stores);
  const { domainData, featureCards } = useSelector((state) => state.Website);

  const { selectedStore, loading, storesList, totalRecords, totalPages } =
    useSelector((state) => state.Stores);

  const { couponByID, getEndUser } = useSelector((state) => state.Coupon);
  const [selectedCoupon, setSelectedCoupon] = React.useState(null);

  const itemsPerPage = 15;
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(0);
  // const [filterBy, setFilterBy] = useState("Active");
  const descriptionRef = useRef();

  // const handleOptionSelect = (eventKey, event) => {
  //   setFilterBy(eventKey);
  // };

  useEffect(() => {
    if (match.params.couponId !== undefined && couponByID?._id === undefined) {
      dispatch(getCouponByIdAction({ coupon_id: match.params.couponId }));
    }
    if (match.params.couponId !== undefined && couponByID?._id !== undefined) {
      setSelectedCoupon(couponByID);
      window.open(
        `/couponsredirect/store/${match.params.storeSlug}/coupon/${match.params.storeName}/${match.params.couponId}`
      );
    }
  }, [match, couponByID, dispatch]);

  useEffect(() => {
    setLastPage(totalPages);
  }, [totalPages]);

  useEffect(() => {
    if (!featureCards) {
      dispatch(getFeatureCardsAction());
    }
  }, []);

  const handlePageChange = (pg) => {
    window.scrollTo(0, 0);
    setCurrentPage(pg);
  };

  useEffect(() => {
    if (match?.params?.storeName && storesList.length > 0) {
      const store = storesList.filter(
        (store) => store?.slug === match?.params?.storeName
      )[0];

      let payload = {
        storeId: store?._id,
        perPage: itemsPerPage,
        currentPage: currentPage,
        resolution: `${window.screen.width}x${window.screen.height}`,
        // filterBy
  
      };
      dispatch(getCouponsStoreByIdAction(payload));
    }
  }, [currentPage, dispatch, match, storesList, ]);

  useEffect(() => {
    dispatch(getTopVisitedStores());
  }, [dispatch]);

  useEffect(() => {
    if (match.params.couponId !== undefined && couponByID?._id === undefined) {
      dispatch(getCouponByIdAction({ coupon_id: match.params.couponId }));
    }
    if (match.params.couponId !== undefined && couponByID?._id !== undefined) {
      setSelectedCoupon(couponByID);
      window.open(
        `/couponsredirect/store/${match.params.storeSlug}/coupon/${match.params.storeName}/${match.params.couponId}`
      );
    }
  }, [match, couponByID, dispatch]);

  useEffect(() => {
    setLastPage(totalPages);
  }, [totalPages]);

  useEffect(() => {
    dispatch(getEndUserAction());
  }, [dispatch]);

  return (
    <>
      <Helmet>
        <title>{(selectedStore?.slug || "") + " - " + domainData?.name}</title>
      </Helmet>
      {loading ? (
        <>
          <div className="w-100 h-100 d-flex align-items-center justify-content-center">
            <Loader />
          </div>
        </>
      ) : selectedStore?.v2_store?.[0].is_paused === false ? (
        <>
          <Head store={selectedStore} descriptionRef={descriptionRef} />

          <div className="body">
            <Container style={{ padding: "0px" }}>
              <Row className="flex-column-reverse flex-md-row">
                <Col sm={12} md={4} lg={3} className="mt-2">
                  <div className="w-100 my-2 popularStore">
                    <p>
                      <b>Popular Stores</b>
                    </p>
                    <ul>
                      {storesList.slice(0, 10).map((store, index) => (
                        <li key={index}>
                          <Link
                            className="popularStoreLink"
                            to={`/store/${store?.slug}`}
                          >
                            {store?.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="w-100 my-2 popularStore">
                    {selectedStore.long_description && (
                      <>
                        <p>
                          <b>About Store :</b>
                        </p>
                        <MonthYearMacros input={selectedStore?.summary} />
                        <br />
                        <MonthYearMacros
                          input={selectedStore.long_description}
                        />

                        <br />
                      </>
                    )}
                  </div>

                  <div className="w-100 my-2 mostTrending">
                    <p className="mb-2">
                      <b>Most Trending</b>
                    </p>

                    {topRatedStores?.map((store, index) => (
                      <Link
                        to={`/store/${store?.store_details?.slug}`}
                        key={index}
                        style={{ textDecoration: "none" }}
                      >
                        <div className="d-flex ">
                          <img
                            src={`${BASE_URL}/${store?.store_details?.image}`}
                            height="50"
                            width="45"
                            alt=""
                          />
                          <p className="p-0 mt-2 mx-3 text-black">
                            {store?.store_details?.slug}
                          </p>
                        </div>
                      </Link>
                    ))}
                  </div>

                  <div className="w-100 my-2 popularStore">
                    <Banner getEndUser={getEndUser} />
                  </div>
                </Col>

                <Col sm={12} md={8} lg={9} className="mt-3">
                  {/* <div

                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                      background: "white",
                      alignContent: "center",
                      padding: "7px",
                    }}
                  >
                    <span>
                      <BiFilterAlt />
                    </span>{" "}
                    <span class="mx-2"> Status: </span>
                    <div style={{ backgroundColor: "#ffffff !important" }}>
                      <DropdownButton
                        id="dropdown-button-drop-sm"
                        size="sm"
                        variant="light"
                        title={filterBy}
                        style={{
                          // border: "1px solid #dddddd",
                          borderRadius: "4px",
                          backgroundColor: "#ffffff !important",
                        }}
                        onSelect={(event) => handleOptionSelect(event)}
                      >
                        <Dropdown.Item
                          eventKey="Active"
                          // onSelect={handleOptionSelect}
                        >
                          Active
                        </Dropdown.Item>
                        <Dropdown.Item
                          eventKey="Expired"
                          // onSelect={handleOptionSelect}
                        >
                          Expired
                        </Dropdown.Item>
                        <Dropdown.Item
                          eventKey="All"
                          // onSelect={handleOptionSelect}
                        >
                          All
                        </Dropdown.Item>
                      
                      </DropdownButton>
                    </div>
                  </div> */}

                  {selectedStore?.coupons.length > 0 ? (
                    <>
                      <div className="couponsContainer">
                        {selectedStore?.coupons.map((coupon, index) => (
                          <>
                            <CouponCardHorizontal
                              coupon={coupon}
                              image={selectedStore.image}
                              key={index}
                              history={history}
                              match={match}
                              selectedStore={selectedStore}
                              selectedCoupon={selectedCoupon}
                              setSelectedCoupon={setSelectedCoupon}
                              loading={loading}
                            />

                            {index === 1 && (
                              <div
                                style={{
                                  backgroundColor: "white",
                                  margin: "1% 0",
                                  paddingBottom: "2.5%",
                                  paddingTop: "1%",
                                }}
                              >
                                <Slider getEndUser={getEndUser} />
                              </div>
                            )}
                          </>
                        ))}
                      </div>
                      <Pagniation
                        lastPage={lastPage}
                        currentPage={currentPage}
                        onClick={handlePageChange}
                        entries={totalRecords}
                        limit={itemsPerPage}
                        style={{ padding: "15px", margin: "5px" }}
                      />
                    </>
                  ) : (
                    <p
                      style={{
                        width: "100%",
                        fontSize: "14px",
                        fontWeight: "bold",
                        textAlign: "center",
                        margin: "50px auto ",
                      }}
                    >
                      No coupon available
                    </p>
                  )}

                  <Col
                    ref={descriptionRef}
                    style={{
                      backgroundColor: "white",
                      width: "100%",
                      padding: "20px",
                    }}
                    sm={12}
                    md={8}
                    lg={9}
                    className="mt-3"
                  >
                    {selectedStore.description && (
                      <MonthYearMacros input={selectedStore.description} />
                    )}
                  </Col>
                </Col>
              </Row>
            </Container>
            <br />
            <NewsLetter />
          </div>
        </>
      ) : (
        <div></div>
      )}
    </>
  );
}

export default Index;
